import Api from "../helpers/api";

export const vratZoznamSelectu = async (typ) => {
  try {
    const response = await Api.get(`/api/v1/smartmap/select/${typ}`);
    return response.data;
  } catch (error) {
    console.error(error);
  }
};
